import React, { useState, useEffect } from 'react';

import styled from 'styled-components';

import * as MUIIcon from '@mui/icons-material';

import { Theme } from '../Theme';

import { formatCurrency } from '../../../commons/utils';
import { TextField } from '../Input';
import { InputAdornment } from '@mui/material';

export const PriceColumn = styled.div`
	flex: 1;
	text-align: center;
	padding: 0 5px;
	min-width: 10.75rem;
	font-family: inherit;
	font-size: inherit;
	justify-content: center;
`;

const ResetIcon = styled(MUIIcon.Cancel)`
	display: none !important;
	color: ${Theme.mediumGrey};
	font-size: 14px !important;
	cursor: pointer;
	margin: 0 0.25rem;

	&:hover {
		color: ${Theme.red};
	}
`;

export const PriceInput = styled(TextField)`
	width: 8rem !important;
	height: 2rem !important;
	padding: 0 !important;
	margin: 0 !important;
	font-weight: 600 !important;

	& .MuiInputBase-input {
		text-align: center !important;
		color: ${(props) => (props.disabled ? Theme.darkGrey : null)} !important;
		background: ${(props) => (props.error ? Theme.lightError : null)} !important;
		cursor: ${(props) => (props.disabled ? 'not-allowed' : 'text')} !important;

		::placeholder,
		::-webkit-input-placeholder {
			color: ${(props) => (props.disabled ? Theme.darkGrey : null)} !important;
		}
	}

	&:hover ${ResetIcon} {
		display: ${(props) => (props.showAdornment && !props.disabled ? 'block' : 'none')} !important;
	}
`;

export const Price = React.forwardRef(
	({ locked = false, placeholder = '$0.00', disabled = true, onBlurHandler = null, showReset = false, onResetHandler = null, defaultValue = null, error = '' }, ref) => {
		const [price, setPrice] = useState(defaultValue);

		useEffect(() => {
			setPrice(defaultValue);
		}, [defaultValue]);

		return (
			<PriceInput
				ref={ref}
				secondary
				name='price-input'
				placeholder={placeholder}
				value={price || ''}
				disabled={disabled}
				error={locked || error}
				onBlur={async (e) => {
					const formattedValue = formatCurrency(e.target.value, true);
					e.target.value = formattedValue;

					const isValid = await onBlurHandler(formattedValue);
					if (isValid === false) setPrice(defaultValue);
					else setPrice(formattedValue);
				}}
				onChange={(e) => {
					setPrice(formatCurrency(e.target.value));
				}}
				showAdornment={showReset}
				endAdornment={
					showReset ? (
						<InputAdornment
							position='end'
							style={{ margin: '0' }}
						>
							<ResetIcon
								onClick={(e) => {
									setPrice(null);
									onResetHandler(e);
								}}
							/>
						</InputAdornment>
					) : null
				}
			/>
		);
	}
);
